import { GlEmptyState, GlSkeletonLoader } from '@gitlab/ui';
import { createAlert } from '~/alert';
import axios from '~/lib/utils/axios_utils';
import { joinPaths } from '~/lib/utils/url_utility';
import Tracking from '~/tracking';
import { helpPagePath } from '~/helpers/help_page_helper';
import DeleteImage from '../components/delete_image.vue';
import DeleteAlert from '../components/details_page/delete_alert.vue';
import DeleteModal from '../components/delete_modal.vue';
import DetailsHeader from '../components/details_page/details_header.vue';
import PartialCleanupAlert from '../components/details_page/partial_cleanup_alert.vue';
import StatusAlert from '../components/details_page/status_alert.vue';
import TagsList from '../components/details_page/tags_list.vue';
import { ALERT_DANGER_IMAGE, FETCH_IMAGES_LIST_ERROR_MESSAGE, UNFINISHED_STATUS, MISSING_OR_DELETED_IMAGE_TITLE, MISSING_OR_DELETED_IMAGE_MESSAGE } from '../constants/index';
import getContainerRepositoryDetailsQuery from '../graphql/queries/get_container_repository_details.query.graphql';
export default {
    name: 'RegistryDetailsPage',
    components: {
        GlEmptyState,
        GlSkeletonLoader,
        DeleteAlert,
        PartialCleanupAlert,
        DetailsHeader,
        DeleteModal,
        TagsList,
        StatusAlert,
        DeleteImage
    },
    mixins: [
        Tracking.mixin()
    ],
    inject: [
        'config'
    ],
    i18n: {
        MISSING_OR_DELETED_IMAGE_TITLE,
        MISSING_OR_DELETED_IMAGE_MESSAGE
    },
    cleanupPoliciesHelpUrl: helpPagePath('user/packages/container_registry/reduce_container_registry_storage', {
        anchor: 'cleanup-policy'
    }),
    garbageCollectionHelpUrl: helpPagePath('administration/packages/container_registry', {
        anchor: 'container-registry-garbage-collection'
    }),
    runCleanupPoliciesHelpUrl: helpPagePath('administration/packages/container_registry', {
        anchor: 'run-the-cleanup-policy'
    }),
    apollo: {
        containerRepository: {
            query: getContainerRepositoryDetailsQuery,
            variables () {
                return this.queryVariables;
            },
            error () {
                createAlert({
                    message: FETCH_IMAGES_LIST_ERROR_MESSAGE
                });
            }
        }
    },
    data () {
        return {
            containerRepository: {},
            itemsToBeDeleted: [],
            mutationLoading: false,
            deleteAlertType: null,
            hidePartialCleanupWarning: false
        };
    },
    computed: {
        queryVariables () {
            return {
                id: joinPaths(this.config.gidPrefix, `${this.$route.params.id}`)
            };
        },
        isLoading () {
            return this.$apollo.queries.containerRepository.loading || this.mutationLoading;
        },
        showPartialCleanupWarning () {
            return this.config.showUnfinishedTagCleanupCallout && this.containerRepository?.expirationPolicyCleanupStatus === UNFINISHED_STATUS && !this.hidePartialCleanupWarning;
        },
        // eslint-disable-next-line vue/no-unused-properties -- tracking() is required by Tracking mixin.
        tracking () {
            return {
                label: 'registry_image_delete'
            };
        },
        pageActionsAreDisabled () {
            return Boolean(this.containerRepository?.status);
        }
    },
    methods: {
        confirmDelete () {
            this.$refs.deleteImage.doDelete();
        },
        dismissPartialCleanupWarning () {
            this.hidePartialCleanupWarning = true;
            axios.post(this.config.userCalloutsPath, {
                feature_name: this.config.userCalloutId
            });
        },
        deleteImage () {
            this.itemsToBeDeleted = [
                {
                    ...this.containerRepository
                }
            ];
            this.$refs.deleteModal.show();
        },
        deleteImageError () {
            this.deleteAlertType = ALERT_DANGER_IMAGE;
        },
        deleteImageIniit () {
            this.itemsToBeDeleted = [];
            this.mutationLoading = true;
        },
        showAlert (alertType) {
            this.deleteAlertType = alertType;
        }
    }
};
